import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillReceiveProps(e) {
  }

  render() {
    let { language, lang } = this.props
    return (
      <div className="reportTitle2">
        <div className="title">
          {lang.ruleTitle}
        </div>
        <div className="content" dangerouslySetInnerHTML={{ __html: lang.ruleContent || "" }}>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/ReportTitle2/index.js